import { signOut } from 'firebase/auth';
import { clearIndexedDbPersistence, terminate } from 'firebase/firestore';
import { auth, db } from '@/lib/firebase';

const KEY = 'vr-auth-denied';

/**
 * Last resort when the profile listener fails for a signed-in user: the usual cause is a
 * session the browser restored after the password was reset outside the portal, which
 * Firebase has revoked. Signing out alone leaves the persisted Firestore cache behind, so
 * the next sign-in trips over it again. Wipe both and reload with the message preserved.
 */
export async function resetLocalSession(message: string): Promise<void> {
  try {
    sessionStorage.setItem(KEY, message);
  } catch {
    /* storage blocked: the message is lost, the reset still runs */
  }
  await signOut(auth).catch(() => undefined);
  try {
    await terminate(db);
    await clearIndexedDbPersistence(db);
  } catch {
    /* cache already gone or locked by another tab: the reload still clears this tab */
  }
  window.location.reload();
}

/** The message stored by a reset before reload, read once. */
export function takeResetMessage(): string | null {
  try {
    const m = sessionStorage.getItem(KEY);
    if (m) sessionStorage.removeItem(KEY);
    return m;
  } catch {
    return null;
  }
}
